import type { GenderType } from '@/types/domain/childApply/valueObjects/gender';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 性別
 */
export class Gender extends PrimitiveValueObject<GenderType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: GenderType): Gender {
    return new Gender(value);
  }

  /** ラベル */
  static get label(): string {
    return '性別';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '男';
  }

  /** キー */
  static get key() {
    return 'gender';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
